import { render } from "./CanvasCommunicate.vue?vue&type=template&id=3eecd8b8&scoped=true"
import script from "./CanvasCommunicate.vue?vue&type=script&lang=js"
export * from "./CanvasCommunicate.vue?vue&type=script&lang=js"

import "./CanvasCommunicate.vue?vue&type=style&index=0&id=3eecd8b8&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eecd8b8"]])

export default __exports__